import HttpClient from "../../clients/HttpClient";
import Image, { CreateImageRequest, UpdateImageRequest } from "../../models/Image";

export default class ImagesService {
    static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

    public static async list(params = {}): Promise<Array<Image>> {
        return this.httpClient.get("/image_admin", params).then((res) => {
            return res.data.map((row) => new Image(row));
        });
    }

    public static async getImage(id): Promise<Image> {
        return this.httpClient.get(`/image_admin/${id}`).then((res) => {
            return new Image(res.data);
        });
    }

    public static async addImage(data: CreateImageRequest): Promise<Image> {
        const formData = new FormData();
        formData.append('file', data.file);
        formData.append('name', data.name);
        formData.append('alt', data.alt ? JSON.stringify(data.alt) : null);
        const res = await this.httpClient.call('POST', `/image_admin`, formData, {}, {
            'Content-Type': 'multipart/form-data',
        }, false);
        if (res.status >= 200 && res.status < 300) {
            return new Image(res.data);
        }
        return null;
    }

    public static async editImage(id, data: UpdateImageRequest): Promise<Image> {
        const formData = new FormData();
        if (data.file) {
            formData.append('file', data.file);
        }
        formData.append('name', data.name);
        formData.append('alt', data.alt ? JSON.stringify(data.alt) : null);
        const res = await this.httpClient.call('PUT', `/image_admin/${id}`, formData, {}, {
            'Content-Type': 'multipart/form-data',
        }, false);
        if (res.status >= 200 && res.status < 300) {
            return new Image(res.data);
        }
    }

    public static async deleteImage(id): Promise<boolean> {
        return this.httpClient.delete(`/image_admin/${id}`, null).then((res) => {
            return true;
        });
    }
}


